(function () {
  'use strict';

  var box = document.querySelector('[data-daile-cookie]');
  if (!box || box.hasAttribute('data-privacy-ready')) return;
  box.setAttribute('data-privacy-ready', '');

  var accept = box.querySelector('[data-daile-cookie-accept]');
  var decline = box.querySelector('[data-daile-cookie-decline]');
  var errorMessage = box.querySelector('[data-daile-cookie-error]');
  var apiPromise;
  var saving = false;
  var recording = false;
  var recorderStarted = false;
  var analyticsDenied = false;
  var returnFocus;

  function show(focus) {
    box.hidden = false;
    requestAnimationFrame(function () {
      box.classList.add('is-visible');
      if (focus) accept.focus();
    });
  }

  function hide() {
    box.hidden = true;
    box.classList.remove('is-visible');
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    returnFocus = null;
  }

  function reportError() {
    errorMessage.hidden = false;
    show(false);
  }

  function setBusy(busy) {
    saving = busy;
    accept.disabled = busy;
    decline.disabled = busy;
    box.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function privacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function loadPrivacy() {
    if (privacy()) return Promise.resolve(privacy());
    if (apiPromise) return apiPromise;

    apiPromise = new Promise(function (resolve, reject) {
      var finished = false;
      var timer = setTimeout(function () { finish(new Error('Privacy API timed out')); }, 10000);

      function finish(error) {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        if (error || !privacy()) reject(error || new Error('Privacy API unavailable'));
        else resolve(privacy());
      }

      if (!(window.Shopify && window.Shopify.loadFeatures)) {
        finish(new Error('Privacy API unavailable'));
        return;
      }

      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
      } catch (error) {
        finish(error);
      }
    }).catch(function (error) {
      apiPromise = null;
      throw error;
    });

    return apiPromise;
  }

  function analyticsAllowed() {
    if (analyticsDenied) return false;
    try {
      var api = privacy();
      return !!(api && api.analyticsProcessingAllowed() === true);
    } catch (error) {
      return false;
    }
  }

  function pauseRecording() {
    if (typeof window.smartlook === 'function') window.smartlook('pause');
    recording = false;
  }

  function syncRecording() {
    if (!analyticsAllowed()) {
      if (recording) pauseRecording();
      return;
    }

    var key = box.getAttribute('data-smartlook-key');
    if (!key) return;

    if (!recorderStarted) {
      recorderStarted = true;
      if (typeof window.smartlook !== 'function') {
        var recorder = function () { recorder.api.push(arguments); };
        recorder.api = [];
        window.smartlook = recorder;
        var script = document.createElement('script');
        script.async = true;
        script.charset = 'utf-8';
        script.src = 'https://web-sdk.smartlook.com/recorder.js';
        window.smartlook('init', key, { region: 'eu' });
        document.head.appendChild(script);
      } else {
        window.smartlook('resume');
      }
      recording = true;
    } else if (!recording) {
      window.smartlook('resume');
      recording = true;
    }
  }

  function saveConsent(api, granted) {
    return new Promise(function (resolve, reject) {
      var finished = false;
      var timer = setTimeout(function () { finish(new Error('Consent save timed out')); }, 10000);

      function finish(result) {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        var error = typeof result === 'string' || Object.prototype.toString.call(result) === '[object Error]' || (result && result.error);
        if (error) {
          reject(result);
          return;
        }
        try {
          var saved = api.currentVisitorConsent();
          var expected = granted ? 'yes' : 'no';
          if (['analytics', 'marketing', 'preferences'].some(function (category) {
            return saved[category] !== expected;
          })) throw new Error('Consent save was not confirmed');
          resolve();
        } catch (readError) {
          reject(readError);
        }
      }

      try {
        api.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted }, finish);
      } catch (error) {
        finish(error);
      }
    });
  }

  function choose(granted) {
    if (saving) return;
    setBusy(true);
    errorMessage.hidden = true;
    if (!granted) {
      analyticsDenied = true;
      pauseRecording();
    }

    loadPrivacy().then(function (api) {
      return saveConsent(api, granted);
    }).then(function () {
      analyticsDenied = !granted;
      hide();
      syncRecording();
    }).catch(function (error) {
      var message = error && error.message;
      if (!message && error && error.error) message = [].concat(error.error).join('; ');
      if (!message && typeof error === 'string') message = error;
      console.warn('[DAILE privacy] Consent update failed:', message || 'Consent API rejected the request');
      reportError();
    }).finally(function () {
      setBusy(false);
    });
  }

  accept.addEventListener('click', function () { choose(true); });
  decline.addEventListener('click', function () { choose(false); });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-daile-cookie-settings]');
    if (!trigger) return;
    event.preventDefault();
    returnFocus = trigger;
    errorMessage.hidden = true;
    show(true);
  });

  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail && event.detail.analyticsAllowed === false) {
      analyticsDenied = true;
      pauseRecording();
    } else if (!saving) {
      analyticsDenied = false;
    }
    syncRecording();
  });

  loadPrivacy().then(function (api) {
    syncRecording();
    if (api.shouldShowBanner()) show(false);
  }).catch(reportError);
})();
